<template>
    <div id="Volumen_div" class="w-100 px-0 py-1">
        <div id="TituloDetalleDeDocumento_div">
            <h5 class="label-black" style="margin-bottom: 0px;">{{pageTitle}}</h5>
            <h6 class="label-black" style="margin-top: 0px;">Gestión de Volumenes de un Documento</h6>
        </div>
        <div class="row d-flex">
            <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low" style="margin-top:0px;margin-bottom:0px;">
                <div class="area custom-area">
                    <div id="Edicion_div">
                        <div class="row">
                            <div class="form-group col-4" id="Fojas_div"> 
                                <label class="label-black">Fojas</label>                                  
                                <input type="text" class="form-control" v-model="Volumenes.Fojas" />
                            </div>
                            <div class="form-group col-4" id="Contenedor_div"> 
                                <label class="label-black">Contenedor</label>
                                <input type="text" class="form-control" v-model="Volumenes.Contenedor" />
                            </div>
                            <div class="form-group col-4" id="BusquedaEstatus_div"> 
                                <label class="label-black">Estatus del Volumen</label>
                                <Estatus 
                                    v-on:valorParaElPadre="cambioDeEstatus" 
                                    :prefijo ="enumeraciones.etiquetasDeHTML.Select"
                                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                    :idDelInput="'Busqueda_TipoEstatus'" 
                                    :valorDefinido="parametros_TipoEstatus.tipoEstatusVolumenId = parametros_TipoEstatus.tipoEstatusVolumenId != undefined && parametros_TipoEstatus.tipoEstatusVolumenId !=null ? parametros_TipoEstatus.tipoEstatusVolumenId : -1"
                                    :parametros ="parametros_TipoEstatus.parametros"
                                    :key="parametros_TipoEstatus.key = parametros_TipoEstatus.tipoEstatusVolumenId != undefined && parametros_TipoEstatus.tipoEstatusVolumenId != null ? parametros_TipoEstatus.tipoEstatusVolumenId : ''"
                                >
                                </Estatus>
                            </div>
                        </div>
                        <div class="row">
                           
                            <div class="form-group col-8" id="BusquedaArea_div"> 
                                <label>Ubicación</label>                                  
                                <CAreas
                                    v-on:valorParaElPadre="cambioDeArea" 
                                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                    :idDelInput="'Busqueda_Area'" 
                                    :valorDefinido="parametros_Area.areaId" 
                                    :parametros="parametros_Area.parametros"
                                    :key="parametros_Area.areaId"
                                    >
                                </CAreas>
                            </div>
                            <div class="form-group col-4" id="FechaREgistro_div"> 
                                <label class="label-black">Fecha de Registro</label>
                                <input type="text" class="form-control" v-model="Volumenes.FechaRegistro" readonly/>
                            </div>
                            
                        </div>
                        
                        <div class="row">
                            <div class="form-group col-4">
                                <button class="btn btn-custom"  @click='ActualizarVolumen()'>&nbsp;&nbsp;&nbsp;Aceptar&nbsp;&nbsp;&nbsp;</button>
                            </div>
                            <div class="form-group col-4">
                                <button class="btn btn-secondary"  @click='VueltaInventario()'>&nbsp;&nbsp;Cancelar&nbsp;&nbsp;&nbsp;</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'

export default {
    data(){
        return{
            enumeraciones,
            Volumenes:{
                VolumenId:0,
                Fojas: 0,
                Contenedor: 0,
                Area: {
                    AreaId: Number,
                },
                EstatusVolumenes: {
                    TipoEstatusVolumenId: Number,
                },
                InventarioDocumentoId:0,
                UsuarioQueRegistro: {
                    IdUsuario: 0,
                    Nombre: "",
                    ApellidoPaterno: "",
                    ApellidoMaterno:""
                },
                FechaRegistro: null,
                MovimientoVolumen: {}
            },
            parametros_TipoEstatus: {
                key: "",
                tipoEstatusVolumenId: -1,
                parametros: {}
                },
            parametros_Area: {
                areaId: -1,
                parametros : {
                    conMaterias: true,
                    conOrdenamientoPorSistema:true
                }
                
                //Materias: [ { MateriaId: 1, Activo: true },{ MateriaId: 2, Activo: true }, { MateriaId: 3, Activo: true }, { MateriaId: 4, Activo: true }, { MateriaId: 5, Activo: true } , { MateriaId: 6, Activo: true }, { MateriaId: 9, Activo: true }, { MateriaId: 13, Activo: true } ], 
                
            },
            UbicacionEstatus: {
                areaId: 0,
                tipoEstatusVolumenId: 0,
                parametros: {}
            }, 
            usrArchivo: {}    
        }
    },
    components:{
        Estatus : catalogos.ArchivoJudicial.C004TipoEstatusVolumen,
        CAreas : catalogos.ArchivoJudicial.C001Areas
    },
    props:{
        volumenId: {
                type: Number, default: 0 },
        documentoId: {type: Number, default: 0},
        CodigoId: {type: String, default: ""},
        parametrosEstablecidos: {
            default: () => ({
                AreaId: null,
                TipoEstatusVolumenId: null
            })
        }
        
    },
    mounted(){
        if (this.volumenId != null && this.volumenId != undefined && this.volumenId > 0)
        {this.ObtenerVolumen();}
    },
    computed:{
        pageTitle(){
            if(this.volumenId != null && this.volumenId != undefined && this.volumenId >0)
            {return "EDICION DE VOLUMEN AL DOCUMENTO "} else {return "NUEVO VOLUMEN AL DOCUMENTO "}
            
        }
    },
    
    methods:{
        ObtenerVolumen: function(){
            var peticion = {
                "VolumenId": this.volumenId
            };
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.ArchivoJudicial.ObtenerVolumen, peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then(respuesta => {
                if (respuesta.data.SiHayError){
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    comun.SeEstaCargandoInformacion(false);
                }
                else
                {
                    
                    let volumen = respuesta.data.GetVolumen;
                    this.Volumenes.VolumenId =volumen.VolumenId;
                    this.Volumenes.InventarioDocumentoId = volumen.InventarioDocumentoId;
                    this.Volumenes.Fojas = volumen.Fojas;
                    this.Volumenes.Contenedor = volumen.Contenedor;
                    this.parametros_Area.areaId= volumen.Area.AreaId;
                    this.Volumenes.UsuarioQueRegistro.IdUsuario = volumen.UsuarioQueRegistro.IdUsuario;
                    this.Volumenes.UsuarioQueRegistro.Nombre = volumen.UsuarioQueRegistro.Nombre;
                    this.Volumenes.UsuarioQueRegistro.ApellidoPaterno = volumen.UsuarioQueRegistro.ApellidoPaterno;
                    this.Volumenes.UsuarioQueRegistro.ApellidoMaterno = volumen.UsuarioQueRegistro.ApellidoMaterno;
                    this.parametros_TipoEstatus.tipoEstatusVolumenId = volumen.EstatusVolumenes.TipoEstatusVolumenId;
                    this.Volumenes.FechaRegistro =moment(volumen.FechaRegistro).format('DD-MM-YYYY HH:mm');
                    this.Volumenes.MovimientoVolumen = volumen.MovimientoVolumen;
                    this.UbicacionEstatus.areaId = volumen.Area.AreaId;
                    this.UbicacionEstatus.tipoEstatusVolumenId = volumen.EstatusVolumenes.TipoEstatusVolumenId;
                    this.usrArchivo = respuesta.data.usuario;
                }
                comun.SeEstaCargandoInformacion(false);
                
            })
            .catch(e=> {
                console.log("No Hay Respuesta del Servidor", e);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
            });
            
        },
        cambioDeEstatus(datos){
            this.parametros_TipoEstatus.tipoEstatusVolumenId = parseInt(datos.target.value);
        },
        cambioDeArea(datos){
            this.parametros_Area.areaId = parseInt(datos[0].target.value);
            if(this.parametros_Area.areaId == 21)
            {
                this.parametros_TipoEstatus.tipoEstatusVolumenId =1;
            }
            else{
                this.parametros_TipoEstatus.tipoEstatusVolumenId =3;
            }
        },
        ActualizarVolumen: function(){
            var MovimientoDocumentos ={};
            var user = this.usrArchivo;
            
            if(this.UbicacionEstatus.areaId != this.parametros_Area.areaId && this.UbicacionEstatus.tipoEstatusVolumenId!=this.parametros_TipoEstatus.tipoEstatusVolumenId)
            {
                if(this.Volumenes.VolumenId!=null && this.Volumenes.VolumenId!=0)
                {
                MovimientoDocumentos =
                    {
                        "AreaQuePresta": {"AreaId": this.UbicacionEstatus.areaId },
                        "AreaQueRecibe": {"AreaId": this.parametros_Area.areaId },
                        "IncidenteId": null,
                        "Observaciones": "Movimiento generado por correción de ubicación del documento",
                        "TiposMovimientos": {"TipoMovimientoId": this.parametros_TipoEstatus.tipoEstatusVolumenId},
                        "UsuarioQuienPresta": {"IdUsuario": this.UbicacionEstatus.areaId!=21 ? 6 : this.usrArchivo.IdUsuario},
                        "UsuarioQuienRecibe": {"IdUsuario": this.parametros_Area.areaId!=21 ? 6 : this.usrArchivo.IdUsuario},
                        "UsuarioQuienRegistra": {"IdUsuario": this.usrArchivo.IdUsuario },
                        "VolumenId": this.Volumenes.VolumenId,
                    }
                }
                else
                {
                    MovimientoDocumentos = null;
                }
                
            }
            if(this.UbicacionEstatus.areaId == this.parametros_Area.areaId)
            {
                MovimientoDocumentos= null;
            }
            var peticion= { 
                "DocumentoId":this.documentoId,
                "Volumenes":{
                    "VolumenId": this.Volumenes.VolumenId,
                    "Fojas": this.Volumenes.Fojas,
                    "Contenedor": this.Volumenes.Contenedor,
                    "Area": {"AreaId": parseInt(this.parametros_Area.areaId)},
                    "InventarioDocumentoId": this.Volumenes.InventarioDocumentoId,
                    "EstatusVolumenes":{ "TipoEstatusVolumenId": parseInt(this.parametros_TipoEstatus.tipoEstatusVolumenId )},
                    "UsuarioQueRegistra": {"IdUsuario": parseInt(this.Volumenes.UsuarioQueRegistro.IdUsuario)},
                    "FechaRegistro": this.Volumenes.FechaRegistro
                     },
                MovimientoDocumentos
                };
                
                    comun.SeEstaCargandoInformacion(true);
                    axios.post(api.conexion + api.ArchivoJudicial.GuardarVolumen, peticion,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                    .then(respuesta => {
                      if (respuesta.data.SiHayError){
                            console.log(respuesta);
                            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                            comun.SeEstaCargandoInformacion(false);
                        }
                        else{
                            
                            if (this.Volumenes.VolumenId > 0)
                            {
                                comun.mensajeDeAlerta("Se Modifico satisfactoriamente el Volumen");
                            }
                             else
                             {
                                comun.mensajeDeAlerta("Se Creo satisfactoriamente el Volumen");
                             }
                            comun.SeEstaCargandoInformacion(false);
                           
                            this.VueltaInventario();
                           
                        }
                        
                    })
                    .catch(e=> {
                        console.log("No Hay Respuesta del Servidor" + e);
                        comun.SeEstaCargandoInformacion(false);
                        comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
                        });
        },
        VueltaInventario: function() {
            router.push ({name: 'Inventario', params: {barraCode: this.CodigoId, ActualizaConsulta: true}});
        }
    }
}

</script>

<style scoped>
input[type="text"]:read-only {
    background: #f3f3f3;
  }

input[type="text"]:read-only:focus {
      color: #fff;
}
.custom-area {
  background-color: #7e7f74;
}
.label-black {
  color: black;
}
.btn-custom {
  background-color: #004746;
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Inventario/EditarVolumen.vue